export const initialState = {
    activeProfiles: undefined,
    appraisals: undefined,
    availableCompetencies: [],
    competencies: undefined,
    discussionPoints: undefined,
    error: false,
    forbidden: false,
    loading: false,
    one2OneNotes: undefined,
    profile: undefined,
    ratingsOverTime: undefined,
    saving: false,
    showSuccess: false,
    showSuccesses: {},
    task: undefined,
    taskList: { records: 0, tasks: undefined },
    taskProgress: undefined,
    taskSummary: undefined,
    team: undefined,
    teamMates: undefined,
};
